import { render, staticRenderFns } from "./FieldErrorTips.vue?vue&type=template&id=ff2d6d66&scoped=true&"
import script from "./FieldErrorTips.vue?vue&type=script&lang=js&"
export * from "./FieldErrorTips.vue?vue&type=script&lang=js&"
import style0 from "./FieldErrorTips.vue?vue&type=style&index=0&id=ff2d6d66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2d6d66",
  null
  
)

export default component.exports